import React, { useState, useEffect } from "react";
import AromAssessmentCounterLeft from "../Arom-Assessment-Counter-Left";
import AromAssessmentCounterRight from "../Arom-Assessment-Counter-Right";
import { AROM_ASSESSMENT } from "../../models/Enums";
import { AssessmentKey } from "./arom-assessment-gif";

const AROMRealTime = () => {
  return (
    <>
      <div
        className="arom-realtime-angle"
        id="arom-realtime-angle-left"
        style={{
          position: "absolute", // Use absolute to apply top and left
          top: "130px",
          left: "67px",
          display: "none", // To enable justifyContent
          justifyContent: "space-between",
          gap: "0px",
        }}
      >
        {sessionStorage.getItem("selectedAssesment") === "55" && (
          <div
            style={{
              width: "154px",
              height: "154px",
            }}
          >
            <AromAssessmentCounterLeft />
          </div>
        )}

        <div className="arom-realtime-heading">
          <div>
            <p
              id="arom-left-high-text"
              style={{ color: "white", fontWeight: "700", fontSize: "32px" }}
            >
              Abduction
            </p>
            <span
              id="arom-left-high-value"
              style={{ color: "white", fontWeight: "700", fontSize: "32px" }}
            >
              0°
            </span>
          </div>
          <div>
            <p
              id="arom-left-low-text"
              style={{ color: "white", fontWeight: "700", fontSize: "32px" }}
            >
              Abduction
            </p>
            <span
              id="arom-left-low-value"
              style={{ color: "white", fontWeight: "700", fontSize: "32px" }}
            >
              0°
            </span>
          </div>
        </div>
      </div>
      <div
        className="arom-realtime-angle"
        id="arom-realtime-angle-right"
        style={{
          position: "absolute", // Use absolute to apply top and left
          top: "130px",
          right: "67px",
          display: "none", // To enable justifyContent
          justifyContent: "space-between",
          gap: "0px",
        }}
      >
        {sessionStorage.getItem("selectedAssesment") === "55" && (
          <div
            style={{
              width: "154px",
              height: "154px",
            }}
          >
            <AromAssessmentCounterRight />
          </div>
        )}
        <div className="arom-realtime-heading">
          <div>
            <p
              id="arom-right-high-text"
              style={{ color: "white", fontWeight: "700", fontSize: "32px" }}
            >
              Abduction
            </p>
            <span
              id="arom-right-high-value"
              style={{ color: "white", fontWeight: "700", fontSize: "32px" }}
            >
              0°
            </span>
          </div>
          <div>
            <p
              id="arom-right-low-text"
              style={{ color: "white", fontWeight: "700", fontSize: "32px" }}
            >
              Abduction
            </p>
            <span
              id="arom-right-low-value"
              style={{ color: "white", fontWeight: "700", fontSize: "32px" }}
            >
              0°
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default AROMRealTime;
